export default "__VITE_ASSET__Z_iZgcYL__"